import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	mainContainer: {
		// margin: "2.5rem"
	},
	sectionContainer: {
		marginBottom: "4rem"
	},
	cardListContainer: {
		margin     : "2.5rem",
		paddingTop : "calc(110px)"

	}
} ) );
